import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from './ui/button';

const PrintingInProgress = ({ onDone }) => (
  <div className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/70 p-4 backdrop-blur-sm">
    <div className="w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-2xl">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-50">
        <Printer className="h-7 w-7 animate-pulse text-blue-600" />
      </div>
      <h2 className="text-lg font-semibold text-gray-900">Badge printing in progress…</h2>
      <p className="mt-2 text-sm text-gray-600">
        Finish or cancel the print dialog. You'll return automatically.
      </p>
      <Button
        type="button"
        variant="outline"
        className="mt-5 w-full"
        onClick={onDone}
      >
        Done
      </Button>
    </div>
  </div>
);

export default PrintingInProgress;
